module.exports = __webpack_public_path__ + "static/02-3caae05e4d55acd990073da62aaea84f.jpg";